import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  CssBaseline,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_ICONS, appLogo } from "../../assets";
import appcolors from "../../constants/Colors";
import useNotifications from "../../hooks/useNotifications";
import ProfileMenu from "../MenuDropDown/ProfileMenu";
import { AppBar, Drawer, DrawerHeader } from "./DrawerTheme";
import LanguageMenu from "./LanguageMenu";

const NavigationDrawer = ({ children }) => {
  const { t } = useTranslation(["tabsDrawer", "common"]);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [open, setOpen] = useState(false);
  const USER_ROUTES = useSelector(
    (state) => state.userRoutesReducer.userRoutes
  );
  const {
    allNotifications,
    fetchAllNotifications,
    markUserNotificationRead,
  } = useNotifications();

  React.useEffect(() => {
    if (window?.location.pathname !== "/notifications") {
      fetchAllNotifications();
    }
  }, []);

  const handleDrawerOpen = () => {
    setOpen(false);
  };

  const returnActive = (val, path) => val === path;

  let filterArrr = allNotifications?.filter(
    (itemmmm) => !itemmmm.userStatus.isRead
  );

  return (
    <Box display={"flex"} bgcolor={"#F5F5F5"} minHeight={"100vh"}>
      <CssBaseline />

      {/* App Bar */}
      <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            minHeight: "inherit !important",
            justifyContent: "space-between",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ marginRight: 5, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <Stack gap={2} direction={"row"}>
            {/* <Tooltip title="Customer support">
              <IconButton
                onClick={() => navigate("/customer-support")}
                sx={{
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <img src={APP_ICONS.chatIcon} alt={"icon"} width={30} />
              </IconButton>
            </Tooltip> */}

            {window.location.pathname !== "/notifications" && (
              <Stack>
                <IconButton
                  sx={{ position: "relative" }}
                  onClick={() => {
                    markUserNotificationRead();
                    navigate("/notifications");
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      background: "#7922d8",
                      top: 0,
                      right: 0,
                      height: "20px",
                      width: "20px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography sx={{ color: "#ffff", fontSize: "12px" }}>
                      {filterArrr.length}
                    </Typography>
                  </Box>
                  <img
                    src={APP_ICONS.notificationPurpleIcon}
                    alt="notification-icon"
                    style={{
                      width: 20,
                    }}
                  />
                </IconButton>
              </Stack>
            )}
            <LanguageMenu />
            {/* <NotificationMenu /> */}
            <ProfileMenu />
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Navigation Drawer */}

      <Drawer
        variant="permanent"
        open={open}
        sx={{
          // "&.MuiDrawer-root .MuiDrawer-paper": {
          //   top: "40px",
          // },
          "& .MuiPaper-root": {
            "&::-webkit-scrollbar": {
              // display:"none",
              width: "4px",
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: appcolors.slateGrey,
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: appcolors.secondary,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: appcolors.white,
            },
          },
        }}
      >
        <DrawerHeader>
          {/* <IconButton sx={{ display: "none" }} onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton> */}

          <Box
            component={"img"}
            src={appLogo.eazidayLogo}
            alt={"app-logo"}
            width={35}
            height={"auto"}
            onClick={() => navigate("/")}
            sx={{ cursor: "pointer" }}
          />
        </DrawerHeader>
        <Typography
          mt={0.5}
          variant="h3"
          fontSize={"0.813rem"}
          fontWeight={"600"}
          textAlign={"center"}
          color={"#868E96"}
        >
          {t("mainMenu")}
        </Typography>
        <List disablePadding sx={{ mt: 2, p: "3px" }}>
          {USER_ROUTES.map((val, index) => {
            let isMatched = returnActive(val.path, pathname);
            return (
              <ListItem
                key={index}
                disablePadding
                sx={{
                  mb: "5px",
                  display: "block",
                  borderRadius: "10px",
                  backgroundColor: isMatched
                    ? appcolors.primary
                    : "transparent",
                }}
              >
                <ListItemButton
                  disableRipple
                  onClick={() => navigate(val.path)}
                  sx={{
                    minHeight: 60,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "0.3s",
                    borderRadius: "10px",

                    "&:hover": {
                      ...(!isMatched && { backgroundColor: "#F3EBFF" }),
                    },
                  }}
                >
                  <img
                    src={isMatched ? val.iconActive : val.icon}
                    alt={val.name}
                    width={25}
                    style={{ mb: 1 }}
                  />
                  <ListItemText
                    primary={t(val.name)}
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontSize: "0.75rem",
                        transition: "0.3s",
                        color: isMatched ? appcolors.white : appcolors.black,
                        whiteSpace: "break-spaces",
                      },
                      textAlign: "center",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      {/* rendering components */}
      <Box
        component="main"
        // sx={{ flexGrow: 1, p: "6.5rem 1rem 1rem 1rem", overflow: "auto" }}
        sx={{ flexGrow: 1, p: "3rem 1rem 1rem 1rem", overflow: "auto" }}
      >
        {/* <DrawerHeader /> */}
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default NavigationDrawer;
